
import { defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Alert from '@/common/components/UI/Alert/index.vue'

export default defineComponent({
    components: {
        'the-button': TheButton,
        alert: Alert,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        updated: {
            type: Boolean,
            default: false,
        },
        orderId: {
            type: String,
            required: true,
        },
    },
    emits: ['submit', 'update-order'],
    setup(props, { emit }) {
        const emitSubmit = () => {
            if (props.loading) return
            emit('submit')
        }

        const emitUpdateOrder = () => {
            emit('update-order')
        }

        return { emitSubmit, emitUpdateOrder }
    },
})
